import { FilterOptionOption } from 'chakra-react-select';
import { MemberOption } from './types';

export const getLoadingMessage = () => 'Loading members...';
export const getNoOptionsMessage = () => 'No results';

export const filterOptions = (
  candidate: FilterOptionOption<MemberOption>,
  input: string,
): boolean => {
  const search = input?.toLowerCase();
  const { email, label } = candidate.data;

  if (!search) return true; // If no search input, show all options
  if (!email || !label) return false; // If email or label is missing, do not show the option
  return (
    label.toLowerCase().includes(search) || email.toLowerCase().includes(search)
  );
};
